
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinkolhapur() {



const cardData = {
  keyword: 'Corporate Cab Services in Kolhapur MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Kolhapur MIDC',
  headingDescription: `eTravo delivers reliable and professional corporate cab services in Kolhapur MIDC, catering to the varied transportation needs of industries and businesses in this vibrant industrial zone. Our services include employee transport, executive travel, client pickups, and shuttle operations, all managed with a focus on safety, comfort, and punctuality. With a modern fleet equipped with GPS tracking and experienced chauffeurs, we ensure seamless connectivity across Kolhapur MIDC and surrounding areas. Our flexible rental plans and customized routes help businesses optimize their daily operations and employee commutes efficiently.`,

  top: 'Prominent Industrial and Business Areas in Kolhapur MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Kolhapur MIDC Industrial Park',
      description: `A major industrial hub hosting diverse manufacturing units and commercial establishments. eTravo provides scheduled and on-demand cab services for employees, ensuring timely and comfortable commutes.`
    },
    {
      title: 'Shree Chhatrapati Shahu Sahakari Sakhar Karkhana',
      description: `A well-known sugar factory in the area. Our cab services assist staff and management with daily transportation needs to maintain smooth operations.`
    },
    {
      title: 'Kolhapur Engineering Industries',
      description: `Home to several engineering and manufacturing companies. eTravo’s fleet serves employees and executives with reliable and safe transport options tailored to shift timings.`
    },
    {
      title: 'Phaltan MIDC Zone',
      description: `Nearby industrial area with multiple businesses. Our corporate cab rentals support employee and client travel needs between Kolhapur MIDC and neighboring industrial zones.`
    },
    {
      title: 'Kolhapur Industrial Estate',
      description: `An important commercial and industrial zone. eTravo offers corporate shuttle and client transport services to facilitate efficient business travel.`
    }
  ],

  services: [
    {
      name: 'Kolhapur MIDC Corporate Cab Rentals',
      description: `Flexible cab rental solutions for companies in Kolhapur MIDC, including short-term and long-term rentals. Ideal for daily staff commutes, corporate events, and executive travel.`
    },
    {
      name: 'Employee Transport Cab Kolhapur MIDC',
      description: `Dedicated employee transport services with well-maintained, GPS-enabled vehicles and professional drivers. We accommodate varied shift patterns to ensure timely and safe travel.`
    },
    {
      name: 'Business Cab Services Kolhapur MIDC',
      description: `Corporate cab services for business owners, client visits, and field staff. Our diverse fleet options ensure comfortable and punctual travel across Kolhapur MIDC.`
    },
    {
      name: 'Corporate Staff Cabs Kolhapur MIDC',
      description: `Structured staff transportation with multi-stop routes and real-time tracking to help businesses manage daily employee commutes efficiently.`
    },
    {
      name: 'Reliable Corporate Cab Service Kolhapur MIDC',
      description: `A trusted cab service emphasizing punctuality, vehicle upkeep, and professional drivers, ensuring smooth and dependable daily transportation.`
    },
    {
      name: 'AC Corporate Cabs Kolhapur MIDC',
      description: `Fully air-conditioned cabs providing a comfortable ride for employees and clients in all weather conditions, with regular sanitization and maintenance.`
    },
    {
      name: 'Staff Pickup and Drop Cab Kolhapur MIDC',
      description: `Comprehensive pickup and drop services aligned with company shifts and employee locations, enhancing workforce punctuality and safety.`
    },
    {
      name: 'Affordable Business Cab Rentals Kolhapur MIDC',
      description: `Cost-effective cab rental plans suited for startups to large enterprises, featuring flexible payment and  options to fit your budget.`
    },
    {
      name: 'Executive Cab Services Kolhapur MIDC',
      description: `Premium cab services with luxury vehicles and professional chauffeurs for corporate executives and VIP clients, ensuring discretion and timely arrivals.`
    },
    {
      name: 'Monthly Corporate Cab Rentals Kolhapur MIDC',
      description: `Monthly rental plans designed for consistent employee transport needs with fixed routes, shift-based scheduling, and GPS tracking for safety and transparency.`
    },
    {
      name: 'Industrial Area Employee Transport Kolhapur MIDC',
      description: `End-to-end employee transport coordination within industrial zones, supporting multi-stop routes and group transfers to optimize operations.`
    },
    {
      name: 'Corporate Client Cabs Kolhapur MIDC',
      description: `Comfortable and professional cab services for business meetings, client visits, and corporate events, ensuring timely and hassle-free travel.`
    },
    {
      name: 'Business Meeting Cabs Kolhapur MIDC',
      description: `On-demand cab services for urgent business travel within Kolhapur MIDC and nearby areas, designed for flexibility and promptness.`
    },
    {
      name: 'Kolhapur Industrial Area Cab Hire',
      description: `Dedicated cab hire solutions for staff transport, inter-office commutes, and special corporate occasions with a focus on reliability and safety.`
    },
    {
      name: 'Corporate Shuttle Cabs Kolhapur MIDC',
      description: `Group shuttle services for corporate events, daily staff commute, and meetings, ensuring efficient and timely transportation.`
    }
  ],

  tableData: [
    ['Kolhapur MIDC Corporate Cab Rentals', 'Employee Transport Cab Kolhapur MIDC'],
    ['Business Cab Services Kolhapur MIDC', 'Corporate Staff Cabs Kolhapur MIDC'],
    ['Reliable Corporate Cab Service Kolhapur MIDC', 'AC Corporate Cabs Kolhapur MIDC'],
    ['Staff Pickup and Drop Cab Kolhapur MIDC', 'Affordable Business Cab Rentals Kolhapur MIDC'],
    ['Executive Cab Services Kolhapur MIDC', 'Monthly Corporate Cab Rentals Kolhapur MIDC'],
    ['Industrial Area Employee Transport Kolhapur MIDC', 'Corporate Client Cabs Kolhapur MIDC'],
    ['Business Meeting Cabs Kolhapur MIDC', 'Kolhapur Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Kolhapur MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services for Kolhapur MIDC",
    "WhyChoosedescription": "eTravo offers comprehensive cab services tailored for businesses in Kolhapur MIDC, catering to diverse industries such as manufacturing, engineering, and textiles. Our solutions ensure smooth and timely transportation for employees, reducing commute-related stress and improving workforce productivity. With our focus on reliability and comfort, we help companies streamline their daily operations and maintain punctuality across all shifts."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Business Needs",
    "WhyChoosedescription": "Our fleet includes comfortable sedans, spacious SUVs, and multi-utility vehicles, allowing businesses to select rides that fit their specific requirements—be it daily employee transport, client meetings, or inter-office travel. Each vehicle is regularly maintained and equipped with modern safety and comfort features."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Expertise",
    "WhyChoosedescription": "Our drivers are well-trained professionals familiar with Kolhapur MIDC’s routes, traffic patterns, and nearby industrial areas. Their knowledge ensures efficient navigation, timely arrivals, and a safe journey for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Booking and Shift Scheduling",
    "WhyChoosedescription": "We provide customized booking options that accommodate fixed or rotating shifts, on-demand rides, and long-term contracts. This flexibility supports businesses with dynamic workforce schedules and varying transportation needs."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking and Monitoring",
    "WhyChoosedescription": "All rides are equipped with GPS tracking, enabling corporate clients to monitor trips in real-time for enhanced safety and operational transparency. This feature helps ensure accountability and quick response in case of any travel deviations."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We offer clear and detailed billing statements that include trip logs and fare breakdowns. This transparency simplifies expense management and reimbursement processes for corporate finance teams."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Protocols",
    "WhyChoosedescription": "Our vehicles undergo routine sanitization, and drivers follow strict hygiene guidelines to provide a safe and healthy environment for passengers, adhering to the highest safety standards."
  },
  {
    "WhyChooseheading": "Dedicated Account Management and Support",
    "WhyChoosedescription": "Each corporate client receives personalized assistance from a dedicated account manager who handles bookings, queries, and ensures smooth transportation operations aligned with your company’s unique needs."
  }
]
}

const faqData = [
  [
    {
      question: "Which industrial areas around Kolhapur MIDC do you cover?",
      answer: "We cover all major industrial zones within and around Kolhapur MIDC, ensuring seamless employee transportation across the region."
    },
    {
      question: "Can we arrange recurring rides for our employees?",
      answer: "Yes, eTravo supports recurring ride scheduling to ensure consistent and timely commutes for your workforce."
    },
    {
      question: "Do you offer monthly billing for corporate clients?",
      answer: "Absolutely. We provide monthly billing cycles with detailed invoices to help streamline your company’s expense management."
    },
    {
      question: "Are your drivers trained in corporate etiquette and safety?",
      answer: "Yes, our drivers undergo comprehensive training to maintain professionalism and ensure passenger safety during all rides."
    },
    {
      question: "How do you ensure passenger safety during transportation?",
      answer: "We implement GPS tracking, regular vehicle maintenance, and enforce strict safety protocols to ensure a secure travel experience."
    },
    {
      question: "Is there dedicated support available for corporate clients?",
      answer: "Yes, corporate clients have access to a dedicated account manager and support team for prompt assistance and service customization."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Vijay Kulkarni",
    designation: "Operations Manager, Kolhapur Manufacturing Co.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services have significantly improved our employee commute experience. Their punctuality and professionalism are commendable.”"
  },
  {
    name: "Ms. Anjali Patil",
    designation: "HR Head, Shiv Textile Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“The flexible scheduling and excellent support provided by eTravo have made managing corporate transportation effortless for our team.”"
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kolhapur MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-kolhapur-midc.jpg",
  "description": "Reliable corporate cab service in Kolhapur MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-kolhapur-midc"
  }
};








    return (
        <div>
<Helmet>
  <title>Cab Service in Kolhapur MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Kolhapur MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinkolhapur;